import { Flex } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextHeader2 } from 'uiToolkitV1/Typography';

export const CompensationCreationHeader = ({ title }: { title: string }) => {
  const history = useHistory();

  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <PaperWithShadow w="100%" p="12px" mt="8px">
      <Flex alignItems="center">
        <Button
          StartIcon={ArrowBack}
          variant="tertiary"
          iconSize="24px"
          onClick={handleBackClick}
          startIconProps={{ color: '#666 !important' }}
        />
        <TextHeader2 bold mr="12px">
          {title}
        </TextHeader2>
      </Flex>
    </PaperWithShadow>
  );
};
